import React from 'react';
import logo from '../assets/cclogo.png';
import DropdownMenu from '../components/Dropdown';
import DiscordButton from '../components/Discordbutton';
import '../App.css'; // Make sure to import the CSS file

const Home = () => {
    return( 
        <div className="home-container">
            <div className="login home-card elevated">
                <img src={logo} className="brand-logo" alt="Logo" />
                <h1>Calico County Core</h1>
                <p className="home-subtitle">Welcome — sign in with Discord to continue to your dashboard.</p>
                <DiscordButton />
            </div>
        </div>
    )
};

export default Home;